// Cache configuration
// cachedChatsCount: Maximum number of chats to cache
const cachedChatsCount = 20;

const CACHE_KEY = 'chats_cache';

function getCache() {
  try {
    const cache = localStorage.getItem(CACHE_KEY);
    return cache ? JSON.parse(cache) : null;
  } catch (error) {
    console.error('[chatsCache] Error reading cache:', error);
    return null;
  }
}

function setCache(cache) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
  } catch (error) {
    console.error('[chatsCache] Error writing cache:', error);
  }
}

/**
 * Pull chats from cache
 * Returns cached chats or null if not found
 * @returns {Object|null} Cached chats object or null
 */
export function pullFromCache() {
  return getCache();
}

/**
 * Save chats to cache
 * Limits to cachedChatsCount and updates last accessed
 * @param {Object} chats - The chats object to cache
 */
export function saveToCache(chats) {
  const chatArray = Object.values(chats);
  
  // Sort by last_message_time descending, keep most recent cachedChatsCount
  const sortedChats = chatArray
    .sort((a, b) => new Date(b.last_message_time || 0) - new Date(a.last_message_time || 0))
    .slice(0, cachedChatsCount);
  
  // Convert back to object with IDs as keys
  const limitedChats = {};
  sortedChats.forEach(chat => {
    limitedChats[chat.id] = chat;
  });
  
  setCache(limitedChats);
}
